module.exports = __webpack_public_path__ + "img/okralignment.679ae68b.png";